module.exports = __webpack_public_path__ + "img/HiwaQader-AwKcha.2d3c0887.jpg";